import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {ButtonModule} from 'primeng/button';
import {TooltipModule} from 'primeng/tooltip';
import {TrustUrlPipe} from './pipes/trust-url.pipe';
import {TrustHtmlPipe} from "./pipes/trust-html.pipe";
import {HeaderComponent} from "./components/header/header.component";
import {RippleModule} from "primeng/ripple";
import {EyeComponent} from './components/eye/eye.component';
import {EyeOffComponent} from './components/eye-off/eye-off.component';
import {OverlayPanelModule} from "primeng/overlaypanel";
import { FixCurrencyPipe } from './pipes/fix-currency.pipe';

@NgModule({
  declarations: [
    TrustUrlPipe,
    TrustHtmlPipe,
    HeaderComponent,
    EyeComponent,
    EyeOffComponent,
    FixCurrencyPipe
  ],
    imports: [
        TranslateModule,
        CommonModule,
        RippleModule,
        ButtonModule,
        TooltipModule,
        OverlayPanelModule
    ],
  exports: [
    CommonModule,
    TranslateModule,
    ButtonModule,
    RippleModule,
    TooltipModule,
    TrustUrlPipe,
    TrustHtmlPipe,
    HeaderComponent,
    EyeComponent,
    EyeOffComponent,
    FixCurrencyPipe
  ]
})
export class SharedModule {
}
